import { Location } from "history";
import IntegrationsChannelsWrapper from "../../integrations/wrapper";

export default function AiChannels (props: { location: Location; }) {
  return (
    <div className="flex flex-column gap-4 w-100 h-100 pb-4 px-4 overflow-y-scroll">
      <IntegrationsChannelsWrapper
        mode="channel"
        location={props.location}
        showHeader={false}
      />
    </div>
  )
}
